export default __webpack_public_path__ + "files/284e713e538b7d0d31fabe2a8f1db407.mp3";